// height of loader for replay on issue details page
export const REPLAY_LOADING_HEIGHT = 480;
// height of loader for replay on replay tab of issue details page
export const REPLAY_LOADING_HEIGHT_LARGE = 640;
